// Things related to the shared issues page
const SharedIssues = {
    currentIssueData: null,
    currentIssueEntry: null,
    getIssuesAndUpdatePage: async (grid)=>{
        const sharedIssuesDiv = CP.getel('sharedIssuesDiv');
        const sharedIssuesTitle = CP.getel('sharedIssuesTitle');
        const issueDateDiv = CP.getel('issueDate');
        const issuesContentDiv = CP.getel('issuesContent');
        CP.showEl(sharedIssuesDiv);
        CP.notify("Loading issue details...", true);
        const groupInfo = {
            groupID: grid,
            version: Constants.CurrentVersion
        };
        const displayResult = await IssueDisplayer.fetchAndDisplayIssues(groupInfo, issuesContentDiv, null, CP.showErrorMessage);
        if (displayResult.success) {
            CP.hideNotification();
            const issueEntry = displayResult.issueEntry;
            const issueEntryHash = displayResult.issueEntryHash;
            // Store issue data for export functionality
            SharedIssues.currentIssueData = displayResult.issueData;
            SharedIssues.currentIssueEntry = {
                entryValue: issueEntry,
                entryHash: issueEntryHash
            };
            if (issueEntry.File?.Filename) sharedIssuesTitle.textContent = Util.getFilenameWithoutExtension(issueEntry.File.Filename);
            issueDateDiv.textContent = CP.getCreatedDateForUI({
                entryData: {
                    entryValue: issueEntry,
                    entryHash: issueEntryHash
                }
            });
            if (CP.isLinked()) {
                let textBubble1 = new CP.TextBubble(CP.MsgManager.staticMsgArea, "", CP.TextBubbleStyle.Simple, null, false);
                textBubble1.setText(CP.getel('linkedMessage1').innerHTML, true);
                let issuesSaveButton = CP.getel('issuesSaveButton');
                CP.showEl(issuesSaveButton);
                issuesSaveButton.onclick = ()=>CP.saveSharedItemToUserGroup({
                        entryHash: issueEntryHash,
                        entryValue: issueEntry
                    }, 'Issues');
            } else {
                let textBubble2 = new CP.TextBubble(CP.MsgManager.staticMsgArea, "", CP.TextBubbleStyle.Simple, null, false);
                textBubble2.setText(CP.getel('unlinkedMessage1').innerHTML, true);
            }
            // Wire export buttons via the centralized helper
            const csvButton = CP.getel('downloadCsvButton');
            const bcfButton = CP.getel('downloadBcfButton');
            CP.showEl(csvButton);
            CP.showEl(bcfButton);
            ExportUtil.wireDownloadButtons(csvButton, bcfButton, ()=>SharedIssues.currentIssueData, ()=>SharedIssues.currentIssueEntry);
            // Wire image viewer using delegated listener
            try {
                if (window.IssueImageViewer) IssueImageViewer.wireDelegated(issuesContentDiv);
            } catch (err) {
                console.error('Failed to initialize image viewer:', err);
            }
        } else {
            CP.hideEl(sharedIssuesDiv);
            CP.showErrorMessage(displayResult.error.message);
        }
    }
};
CP.setupSharedPage(SharedIssues, {
    listItemId: 'sharedIssuesListItem',
    updatePage: SharedIssues.getIssuesAndUpdatePage,
    messageAreasContainerId: 'messageAreas',
    onInvalidLink: ()=>{
        CP.hideEl(CP.getel('sharedIssuesDiv'));
    }
});

//# sourceMappingURL=repo.6feb4c1d.js.map
